var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0 pl-2",
          attrs: { cols: "12", id: "head_title" },
        },
        [
          _c(
            "v-col",
            { staticClass: "pa-0", attrs: { cols: "12", id: "main_content" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/setting" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("title")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/setting/authority" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.ts("shareUserPermissionSettings")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [_vm._v(" " + _vm._s(_vm.ts("mappingCameraGroup")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content", cols: "12", align: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0 pt-9 mb-15",
              attrs: { cols: "10", align: "left" },
            },
            [
              _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 fixed-table",
                    attrs: {
                      items: _vm.records,
                      "items-per-page": _vm.itemsPerPage,
                      "fixed-header": "",
                      height: "70vh",
                      dark: "",
                      "footer-props": {
                        itemsPerPageOptions: [10, 50, 100, 500, -1],
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (ref) {
                          return [
                            _c("thead", [
                              _c(
                                "tr",
                                _vm._l(_vm.headers, function (header) {
                                  return _c(
                                    "th",
                                    {
                                      key: header.value,
                                      class:
                                        header.value === "userName"
                                          ? "sticky-column"
                                          : "",
                                    },
                                    [_vm._v(" " + _vm._s(header.text) + " ")]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "tr",
                              [
                                _c(
                                  "td",
                                  { staticClass: "sticky-column" },
                                  [
                                    _c("v-row", { staticClass: "pl-2" }, [
                                      _vm._v(_vm._s(item.userName)),
                                    ]),
                                    _c("v-row", { staticClass: "pl-2" }, [
                                      _vm._v(_vm._s(item.name)),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  item.cameraGroups,
                                  function (value, key) {
                                    return _c(
                                      "td",
                                      { key: key },
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            "input-value": value,
                                            light: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleCameraGroup(
                                                item,
                                                key
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.dataLoading
                    ? _c(
                        "div",
                        { staticClass: "table_loading_overlay" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "white",
                              width: 4,
                              size: 40,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { align: "center", justify: "end" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue_btn ma-0 pa-0 mt-10 mr-3",
                      attrs: {
                        width: "auto",
                        height: "2rem",
                        id: "blue_btn",
                        loading: _vm.saveLoading,
                        elevation: "0",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.t("save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }